import axios, { AxiosInstance } from 'axios';

import Language from '../entity/Language';

class TranslationBackend {
  private axios: AxiosInstance;
  private appVersion: string;

  constructor({ appVersion }: { appVersion: string }) {
    this.appVersion = appVersion;
    this.axios = axios.create();
  }

  public get = async (language: Language): Promise<Record<string, string>> => {
    const response = await this.axios.get(`/translation/${language}.json?v=${encodeURIComponent(this.appVersion)}`);

    return response.data;
  };
}

export default TranslationBackend;
